var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TabTitle',{attrs:{"title":"代下声明","isShowTips":false}}),_c('div',{staticClass:"table-container"},[_c('download')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }